import PropTypes from 'prop-types';
import React, { useMemo } from "react";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//import components
import TableContainer from '../../components/Common/DataTableContainer';

const VehiclesTable = ({ vehicles }) => {

    const columns = useMemo(
        () => [
          {
            header: "Image",
            accessorKey: "image",
            enableColumnFilter: false,
            cell: ({ row }) => (
              <img
                src={row.original.image || "assets/images/no-image.png"}
                alt="Profile"
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
            )
          },
          {
            header: 'Make Name',
            accessorKey: 'makeName',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Model Name',
            accessorKey: 'modelName',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Body Type',
            accessorKey: 'bodyType',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Vehicle Type',
            accessorKey: 'vehicleType',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'License Plate',
            accessorKey: 'licensePlate',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'In Service?',
            accessorKey: 'in_service',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Is Enable?',
            accessorKey: 'is_enable',
            enableColumnFilter: false,
            enableSorting: true,
          },
        ],
        []
      );

    const totalRecords = vehicles?.length ?? 0;
    
    const transformedData = useMemo(() => {
      return vehicles?.map(item => {
          const vehicleMedia = Array.isArray(item.vehicle_media) ? item.vehicle_media : [];

          return {
              image: vehicleMedia.length > 0 && vehicleMedia[0]?.url
                  ? vehicleMedia[0].url
                  : null,

              makeName: item.make_name || "N/A",
              modelName: item.model_name || "N/A",
              bodyType: item.body_type || "N/A",
              vehicleType: item.type_name || "N/A",
              licensePlate: item.license_plate || "N/A",
              in_service: item.in_service == 1 ? 'YES' : 'NO',
              is_enable: item.is_enable == 1 ? 'YES' : 'NO',
          };
      });
    }, [vehicles]);

    return (
    <>{!vehicles ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}</>
  );
};

VehiclesTable.propTypes = {
  vehicles: PropTypes.any
};

export default VehiclesTable;